import { selectProfileData } from '@pages/profile/store/selectors';
import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import useImmediateApiCall from '../../hooks/useImmediateApiCall';
import Receivables from '../../pages/receivables/Receivables';
import receivableSvc from '../../services/receivables/receivablesSvc';
import RECEIVABLES_TABS from './constants/ReceivablesTable.constants';

enum PayinTypeIdEnum {
  MOVEMENTS = 1,
  PAYMENT_REQUEST = 2,
}

const ReceivableInitializer = () => {
  const [movementType, setMovementType] = useState<
    keyof typeof RECEIVABLES_TABS
  >(RECEIVABLES_TABS.MOVEMENTS as keyof typeof RECEIVABLES_TABS);
  const userProfile = useSelector(selectProfileData);
  const enterpriseId = useMemo(() => {
    if (userProfile?.company) return userProfile?.company?.enterpriseId;
    return null;
  }, [userProfile]);
  const fixedMovementType = useMemo(() => movementType, [movementType]);
  const {
    loading,
    data,
    error,
    retry: getReceivables,
  } = useImmediateApiCall((params) =>
    receivableSvc.getReceivables({
      ...params,
      enterpriseId,
      type: PayinTypeIdEnum[movementType as keyof typeof PayinTypeIdEnum],
    })
  );

  return (
    <Receivables
      loading={loading}
      error={error}
      data={data}
      movementType={fixedMovementType}
      setMovementType={setMovementType}
      getReceivables={getReceivables}
    />
  );
};

export default ReceivableInitializer;
